import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Usage`}</h2>
    <p>{`Radius is the blunt part of the corner of a component that affects the shape and visibility of the content inside.
This is the variant of radius we use globally for property the component.
You can chek out the guideline for more detail description.`}</p>
    <p>{`To get started, simply import the theme and apply the radius to your UI components:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`import ThemeLGNUIKit

let view = UIView()
view.lgnRadius12()
`}</code></pre>
    <div className="divi" />
    <h2>{`Preview`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Shape`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Radius Name`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div className="radius2" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.lgnRadius4()`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div className="radius4" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.lgnRadius8()`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div className="radius5" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.lgnRadius12()`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div className="radius6" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.lgnRadius16()`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div className="radius7" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.lgnRadius24()`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div className="radius8" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.lgnRadiusFull()`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`<uiview>.lgnRadius4()
<uiview>.lgnRadius8()
<uiview>.lgnRadius12()
<uiview>.lgnRadius16()
<uiview>.lgnRadius24()
<uiview>.lgnRadiusfull()
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      